// extracted by mini-css-extract-plugin
export default {"panelHeader":"cb7ffbd8522b","panelFooter":"f50b9542fcdf","innerPanel":"d7330010d38b","settingsPanel":"b3a2ae7149f6","reviewHeader":"a2118d9a6c98"};